import Boss from '@tencent/vft-common/Boss';
import login from '@tencent/vft-common/login';
import cookie from '@tencent/vft-common/cookie';
import assign from 'lodash-es/assign';
import env from '@tencent/vft-common/env';
var reporter = new Boss({
  bossId: 3753,
  pwd: 1449912345
});

function _getPt() {
  var plat = 3000;

  if (env.isIpad) {
    return 5;
  }

  if (env.isApp) {
    if (env.isAndroid) {
      plat = 8;
    } else if (env.isIphone) {
      plat = 7;
    } else if (env.isWin) {
      plat = 2000;
    }
  } else if (env.isMqq) {
    if (env.isAndroid) {
      plat = 8001;
    } else if (env.isIphone) {
      plat = 8002;
    }
  }

  return plat;
}

var pt = _getPt();

function getPresetParams() {
  var presetParam = {
    f_url: '/h5/login-panel/',
    f_url_param: encodeURIComponent(location.href),
    f_dm: 'film.qq.com',
    f_logintype: '',
    f_uid: '',
    f_appid: '',
    f_pt: pt,
    f_guid: cookie.get('guid') || cookie.get('video_guid'),
    f_omgid: cookie.get('video_omgid'),
    _dc: Math.random()
  };

  if (login.isLogin()) {
    presetParam.f_logintype = cookie.get('main_login') || 'qq';
    presetParam.f_vuid = cookie.get('vuserid');

    if (presetParam.f_logintype === 'wx') {
      presetParam.f_uid = cookie.get('openid');
      presetParam.f_appid = cookie.get('appid');
    } else if (presetParam.f_logintype === 'qq') {
      presetParam.f_uid = login.getUin();
    }
  } else {
    presetParam.f_logintype = '-';
  }

  return presetParam;
}

export function expose(param) {
  param = assign(getPresetParams(), param, {
    f_event: 'expose'
  });
  reporter.report(param);
}
export function click(param) {
  param = assign(getPresetParams(), param, {
    f_event: 'click'
  });
  reporter.report(param);
}